
const PREFIXID = 'PLANBT_';

export const planBTTypes = {
    IS_LOADING_LIST_PLANBT: PREFIXID+'IS_LOADING_LIST_PLANBT',
    SET_QUERY_SEARCH: PREFIXID+'SET_QUERY_SEARCH'
}